import { render } from "./CogIcon.vue?vue&type=template&id=18d11f9a&ts=true"
import script from "./CogIcon.vue?vue&type=script&lang=ts"
export * from "./CogIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__